import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/logo@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "logos-wr" }
const _hoisted_5 = { class: "logo-wr" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "counter-wr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "burger-wr" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          ($setup.props.estate?._id)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'EstateMap', params: { estateId: $setup.props.estate._id } }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "logo-img",
                    src: $setup.props.estate?.logoUrl
                  }, null, 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    class: "logo-img",
                    src: _imports_0,
                    srcset: _hoisted_1
                  }, null, -1)
                ]))]),
                _: 1
              }))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode($setup["QuoteRequestCounter"], {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emits('onRequestQuotes'))),
          class: _normalizeClass({ hidden: $props.isReviewQuote })
        }, null, 8, ["class"])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stepper-border" }, null, -1)),
    (!$props.isReviewQuote)
      ? (_openBlock(), _createBlock($setup["StepperLine"], {
          key: 0,
          class: "stepper",
          tabs: [...Object.values($setup.CustomizeHouseStepsEnum)],
          step: $setup.selectedQuote.currentStep,
          skipStepIndex: $setup.props.skipStepIndex
        }, null, 8, ["tabs", "step", "skipStepIndex"]))
      : (_openBlock(), _createBlock($setup["StepperLine"], {
          key: 1,
          class: "stepper",
          tabs: [...Object.values($setup.CustomizeHouseStepsReviewQuoteEnum)],
          step: $setup.CustomizeHouseStepsReviewQuoteEnum.REVIEW_QUOTE,
          stepType: $setup.StepTypeEnum.CUSTOMIZE_HOUSE_STEPS_REVIEW_QUOTE
        }, null, 8, ["tabs", "step", "stepType"]))
  ]))
}